<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-subway`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.268 45.62a1 1 0 01-1.404-.169L6.628 43.88a1 1 0 01.169-1.404L15.036 36H8a2 2 0 01-2-2V4a2 2 0 012-2h32a2 2 0 012 2v30a2 2 0 01-2 2h-6.736l8.24 6.474a1 1 0 01.168 1.405l-1.235 1.572a1 1 0 01-1.405.169L26.79 36h-5.28L9.268 45.62zM38 24H10v8h28v-8zm-20 6v-4h-4v4h4zm16-4v4h-4v-4h4zM10 6h28v14H10V6z"/></svg>
</template>
<script>

export default {
  name: 'IconSubway',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
